componentRegistryInstance.register('html', 'read', 'hrd.components.form.HTMLComponent');

hrd.components.form.HTMLComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.HTMLComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	getReadOnlyField: function(field, name, object, options) {
		this.setValueByPath(object, name, field.html());
	},
	setReadOnlyField: function(field, value, object, options) {
		var html = (value != undefined) ? value : '';
		if (!field.data('keep-font-weight')) {
			field.css('font-weight', 'normal');
		}
		field.html(html);
	}
});